module.exports = __webpack_public_path__ + "assets/img/ic-intro-approve.e06e8d51.png";